import { FunctionComponent } from 'react';
import { CaretLeftIcon } from '@phosphor-icons/react';
import { Link } from 'react-router-dom';

export interface BackLinkProps {
  to: string;
  label?: string;
  className?: string;
}

export const BackLink: FunctionComponent<BackLinkProps> = ({
  to,
  label = 'Back to MyWestminster dashboard',
  className = '',
}) => {
  return (
    <Link
      to={to}
      className={`text-action-link hover:text-action-link-hover inline-flex items-center gap-1 py-7 text-base font-bold underline underline-offset-2 ${className}`}
    >
      <CaretLeftIcon className="h-4 w-4" aria-hidden="true" />
      <span>{label}</span>
    </Link>
  );
};
